import {useQuery} from "react-query";
import roleService from "../../services/RoleService";

export default function useRole(id: number) {
   return useQuery(['role', id], () => roleService.findById(id));
}